let gallery = new SimpleLightbox('.gallery a', { captionDelay: 300 });


// gallery.on('show.simplelightbox', function () {
// 	// do something…
// });

// gallery.on('error.simplelightbox', function (e) {
// 	console.log(e); // some usefull information
// });